<template>
  <div class="hello">
    <div class="loading">
      <van-loading color="#3668A6" />
      <div class="loading-text">加载中</div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .loading{
    font-size: 14px;
    color: #999;
    text-align: center;
    padding: 40px 0;
    .loading-text{
      margin-top: 15px;
    }
  }
</style>

<script>
  export default {
    name: 'HelloWorld',
    data () {
      return {}
    },
    created() {},
    mounted() {},
    components: {},
  }
</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue